import React from "react";
import { AppContextProvider } from "./app-context";
import { AuthContextProvider } from "./auth-context";

const QuoteContextProvider = (props) => {
  return (
    <AppContextProvider>
      <AuthContextProvider>{props.children}</AuthContextProvider>
    </AppContextProvider>
  );
};

export default QuoteContextProvider;
